module.exports = __webpack_public_path__ + "static/media/2.84b19157.JPG";